export default {"src":"/_next/static/media/crossword-puzzle.4eaf286d.svg","height":96,"width":120,"blurWidth":0,"blurHeight":0};